import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import { useValidator } from '../../hooks/formValidator/useValidator';
import { isNotEmpty, isValidEmail } from '../../hooks/formValidator/validators';
import { getPasswordRecoveryLink } from '../../api/admin/auth';
import { useAppDispatch } from '../../store';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { useFocusOnFirstErrorField } from '../../hooks/errorFieldFocus';
const formValidationSchema = {
    email: [isNotEmpty, isValidEmail],
};
const ForgotPasswordForm = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [email, setEmail] = useState('');
    const { formErrors, validateInputField } = useValidator({
        inputSchema: formValidationSchema,
    });
    const orderedRefs = [['email', useRef(null)]];
    const refs = Object.fromEntries(orderedRefs);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [forceFocus, setForceFocus] = useState(false);
    useFocusOnFirstErrorField(formErrors, orderedRefs, forceFocus, setForceFocus);
    const handleSubmit = async () => {
        const isEmailValidationError = validateInputField({ fieldName: 'email', value: email });
        if (isEmailValidationError) {
            setForceFocus(true);
            return;
        }
        setSubmitStatus('pending');
        try {
            await getPasswordRecoveryLink({ email });
            setSubmitStatus('success');
        }
        catch (err) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs("form", { className: 'forgot-password-form', onSubmit: (event) => event.preventDefault(), children: [_jsx(Input, { ref: refs.email, id: 'email', name: 'email', value: email, placeholder: t('placeholder.email'), onChange: (event) => {
                    setEmail(event.currentTarget.value);
                    validateInputField({ fieldName: 'email', value: event.currentTarget.value });
                }, error: !!formErrors.email?.length, errorMessage: !!formErrors.email?.length ? t(formErrors.email[0].messageTranslationKey) : undefined }), submitStatus === 'success' && (_jsx("div", { className: "forgot-password-instruction-message", children: t('admin.forgot_password_instruction') })), _jsx("div", { className: "forgot-password-form-submit", children: _jsx(Button, { onClick: handleSubmit, label: t('button.reset_password'), disabled: submitStatus === 'pending' || submitStatus === 'success' }) })] }));
};
export default ForgotPasswordForm;
